<template>
  <div class="about">
    <div class="container"> 
      <h1 class="headline">{{$t('message.aboutTitle')}}</h1>
      <div v-html="$t('message.aboutContent')"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'about',
  data () {
    return {
      events: null
    }
  },
  methods: {
    getEvents: function () {
      this.$http.post('http://api.everfights.com/getAllEvents',
      {user: 'public', password: 'free4all'},
      { emulateJSON: true }
      ).then(response => {
        // success callback
        this.events = response.body.events
        console.log(response)
      }, response => {
      // error callback
      })
    },
    goCountry: function (id) {
      window.location.href = './#/country/' + id + '/members'
    }
  },
  created: function () {
    // this.getEvents()
  }
}
</script>
